import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

type MotionDivProps = HTMLMotionProps<'div'> & {
  className?: string;
};

const MotionDiv = motion.div as React.FC<MotionDivProps>;

const Home: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-16rem)] text-center">
      <MotionDiv
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-3xl"
      >
        <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600 dark:from-indigo-400 dark:to-purple-400">
          {t('home.title')}
        </h1>
        <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-gray-700 dark:text-gray-200">
          {t('home.subtitle')}
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
          {t('home.description')}
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          {/*<Link
            to="/projects"
            className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition-colors"
          >
            {t('home.viewWork')}
          </Link>*/}
          <Link
            to="/contact"
            className="px-6 py-3 border-2 border-indigo-600 text-indigo-600 dark:border-indigo-400 dark:text-indigo-400 font-medium rounded-lg hover:bg-indigo-50 dark:hover:bg-gray-800 transition-colors"
          >
            {t('home.contactMe')}
          </Link>
        </div>
      </MotionDiv>
    </div>
  );
};

export default Home;
